// Global Instructions Rule Applied!
//
// A control disabled for a reason, with the reason in a Tooltip - the full-form
// button grammar's "current-step blocks are disabled with a tooltip reason"
// (docs/FRONTEND_DESIGN_PATTERNS.md) and the user-rights rule "an action on a
// record the user can see but not do: disabled, with the reason"
// (docs/USER_RIGHTS_DESIGN.md 5.4).
//
// With no reason it renders the control as it is. The span lets the Tooltip
// fire on a disabled antd Button, which swallows pointer events (antd 5.27).
//
//   const book = useCapability('asset_transactions.book')
//   <DisabledReason reason={book.reason}>
//     <Button disabled={!book.allowed}>Book</Button>
//   </DisabledReason>
import React from 'react'
import { Tooltip } from 'antd'

interface DisabledReasonProps {
  /** Why the control is disabled; null or empty when it is not. */
  reason: string | null | undefined
  children: React.ReactElement
}

export default function DisabledReason({ reason, children }: DisabledReasonProps): React.ReactElement {
  if (!reason) return children
  return (
    <Tooltip title={reason}>
      <span className='inline-block'>{children}</span>
    </Tooltip>
  )
}
